import { render, staticRenderFns } from "./TestValidationList.vue?vue&type=template&id=207a06c4"
import script from "./TestValidationList.vue?vue&type=script&lang=js"
export * from "./TestValidationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207a06c4')) {
      api.createRecord('207a06c4', component.options)
    } else {
      api.reload('207a06c4', component.options)
    }
    module.hot.accept("./TestValidationList.vue?vue&type=template&id=207a06c4", function () {
      api.rerender('207a06c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/validation/TestValidationList.vue"
export default component.exports